<template>
  <div id="device-count">
    <dv-border-box-13 class="device-count-all">
      <div class="device-count-top">
        <dv-decoration-7>&nbsp; {{$t('deviceSummary')}} &nbsp;</dv-decoration-7>
      </div>
      <div class="device-count-main">
        <div class="device-main-content">
          <div class="device-main-num">
            <dv-decoration-9 class="device-num-con" :dur=5 ::color="['#4A90E2', '#1F2F50']">{{count}}</dv-decoration-9>
          </div>
          <div class="device-main-name">
            <span class="device-name-con">{{$t('totalDevice')}}</span>
          </div>
        </div>
        <div class="device-main-content">
          <div class="device-main-num">
            <dv-decoration-9 class="device-num-con" :dur=5 :color="['#34D1BF', '#0B3C49']">{{onLine}}</dv-decoration-9>
          </div>
          <div class="device-main-name">
            <span class="device-name-con">{{$t('onLine')}}</span>
          </div>
        </div>
        <div class="device-main-content">
          <div class="device-main-num">
            <dv-decoration-9 class="device-num-con" :dur=5 :color="['#FF6B6B', '#3B0A0A']">{{offLine}}</dv-decoration-9>
          </div>
          <div class="device-main-name">
            <span class="device-name-con">{{$t('offLine')}}</span>
          </div>
        </div>
      </div>
    </dv-border-box-13>
  </div>
</template>

<script>
  export default {
    name: 'DeviceCount',
    data() {
      return {
        count: '0',
        onLine: '0',
        offLine: '0',
      }
    },

    methods: {
      getDeviceNumInfo(count, onLine) {
        this.count = count;
        this.onLine = onLine;
        this.offLine = count - onLine;
      }
    }
  }
</script>

<style scoped lang="less">
  @import "less/DeviceCount.less";
</style>





// WEBPACK FOOTER //
// src/components/DeviceCount.vue